<div class="tutorial-options">
  @for (p of presetsService.progressPresets; track p.key) {
    <div class="tutorial-option preset-option" [class.selected]="filter.progressPreset === p.key" (click)="setPreset(p.key)">
      <h3>{{ p.label }}</h3>
      <div class="extra-info">Level {{ p.level }}</div>
      <div class="preset-image-wrap">
        <img class="tutorial-option-image" src="{{ prefix }}/img/presets/{{ p.img }}"/>
        <button type="button" class="preset-preview-btn" title="Preview changes" (click)="previewProgressPreset(p.key); $event.stopPropagation()">
          <span class="icon icon-zoom-in"></span>
        </button>
      </div>
    </div>
  }
</div>

<div class="section-row">
  <app-tooltip-wrapper [fullWidth]="true">
    <div class="title-toggle-btn">
      <span class="input-group-btn">
        <button class="btn toggle-btn" [class.off]="!filter.ssf" (click)="toggleSsf()"></button>
      </span>
      I'm playing Solo-Self-Found (<strong>SSF</strong>) <span class="extra-info"> (?)</span>
      <ng-template #tooltip>
        - Selects the <strong>SSF Tiering Mode</strong>, which more evenly distributes currency between tiers.
        <br />- Changes some <strong>presets</strong> to show more potentially interesting <span class="rare-item-color">Rares</span>.
        <span class="tooltip-section"><strong>Caution!</strong> Verify the Unique, Chance Base and Gear Tiers and adjust if necessary.</span>
      </ng-template>
    </div>
  </app-tooltip-wrapper>

  <app-tooltip-wrapper [fullWidth]="true">
    <div class="title-toggle-btn">
      <span class="input-group-btn">
        <button class="btn toggle-btn" [class.off]="!changeVisualStyle" (click)="toggleChangeVisualStyle()"></button>
      </span>
      Change Top-Tier Item <strong>Label Styles</strong> <span class="extra-info"> (?)</span>
      <ng-template #tooltip>
        Changes the visual style of Top-Tier Currency, Unique and Chance Base item labels so they stand out more.
        <br />You can further customize this on the <a href="/cosmetic">Cosmetic</a> tab.
        @if (changeVisualStyle && exampleLabelRuleStyled) {
          <br />
          <app-rule-preview [compact]="true" [rules]="[exampleLabelRuleStyled]"></app-rule-preview>
        }
        @if (!changeVisualStyle && exampleLabelRuleUnstyled) {
          <br />
          <app-rule-preview [compact]="true" [rules]="[exampleLabelRuleUnstyled]"></app-rule-preview>
        }
      </ng-template>
    </div>
  </app-tooltip-wrapper>
</div>

<p class="preset-info extra-info">
  @if (poe1 && filter.progressPreset === 'presetMidMaps70' && !filter.ssf) {
    {{ presetsService.poe1progressAtlasNonSsfPresetText }}
  }
  @else if (filter.progressPreset) {
    {{ presetsService.levelPresetTexts[filter.progressPreset!] }}
  }
</p>
